<template>
  <div
    class="user-tex d-flex align-baseline font-weight-bold"
    style="min-height: min-content; margin: 0; padding: 0;"
  >
    <span
      class="whole"
      style="color: var(--text-over-primary);"
      :class="{ small: currency && currency.length > 1 }"
      >{{ whole(balance) }}</span
    >
    <span
      v-if="showDecimal"
      class="decimal"
      style="color: var(--text-over-primary);"
      :class="{ small: currency && currency.length > 1 }"
      >{{ $t("decimal_separator") }}</span
    >
    <span
      v-if="showDecimal"
      class="decimal"
      style="color: var(--text-over-primary);"
      :class="{ small: currency && currency.length > 1 }"
      >{{ decimalAmount != null ? decimalAmount : decimal(balance) }}</span
    >
    <v-icon small style="top: 2px; color: var(--text-over-primary);">{{
      currency
    }}</v-icon>
  </div>
</template>

<script>
import { whole, decimal } from "../utils/MoneyUtils";
import { mapState } from "vuex";

export default {
  props: {
    balance: Number,
    showDecimal: Boolean,
    decimalAmount: String,
  },
  computed: {
    ...mapState({
      currency: (state) =>
        state.customization.customization.economics.currency_symbol,
    }),
  },
  methods: {
    decimal,
    whole,
  },
};
</script>

<style scoped lang="scss">
.whole {
  font-size: 60px;
  &.small {
    font-size: 35px;
  }
}
.decimal {
  font-size: 60px;
  &.small {
    font-size: 35px;
  }
}
.currency {
  font-size: 60px;
  &.small {
    font-size: 35px;
  }
}
.user-tex {
  span,
  .v-icon {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1 !important; // a veces genera espacios innecesarios
  }
}
.user-tex {
  line-height: 1 !important;

  .whole,
  .decimal,
  .v-icon {
    line-height: 1 !important;
  }
}
</style>
